import { handleAPIError } from "@services/Base";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { USER_API_URL } from "../../../config";
import { PatchUser, UserDetailed } from "../types";

export interface IPatchUserMutation {
  user_id: string;
  updates: PatchUser;
}

export const usePatchUser = () => {
  return useMutation({
    mutationFn: ({ user_id, updates }: IPatchUserMutation) => {
      return axios
        .patch(
          `${USER_API_URL}/waves-user-manager-api/v1/users/${user_id}`,
          updates
        )
        .then((response) => {
          return response.data as UserDetailed;
        })
        .catch((error) => {
          return handleAPIError(error);
        });
    }
  });
};
